import { Injectable } from '@angular/core';

import {
  HttpClient,
  HttpEvent,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AIRSearchDTO } from 'app/model/air-search-dto';
import { Observable } from 'rxjs';
import { Http, ResponseContentType, RequestOptions } from '@angular/http';
import { UrlConfigService } from './url-config.service';

@Injectable({
  providedIn: 'root',
})
export class AirMasterService {
  downloadMasterTemplateAIRItems(airSearchDto: AIRSearchDTO) {
    throw new Error('Method not implemented.');
  }

  //url = environment.SERVER_URL;
  url: string;
  token = '';
  TOKEN = 'token';

  constructor(private http: HttpClient, private urlConfigService: UrlConfigService) {
    this.url = this.urlConfigService.apiServerUrl;
  }

  airItemsListDepartmentWise(reqData) {
    return this.http.post(`${this.url}airItems/list-department-wise`, reqData);
  }
  createAIRItem(reqData) {
    return this.http.post(`${this.url}airItems/add`, reqData);
  }
  getAIRMasterTemplateList(airSearchDto: AIRSearchDTO) {
    return this.http.post(`${this.url}airMaster/search`, airSearchDto);
  }
  addDeleteUpdateAIRMasterTemplate(airSearchDto: AIRSearchDTO) {
    return this.http.post(`${this.url}airMaster/crud`, airSearchDto);
  }
  airMasterById(airSearchDto: AIRSearchDTO) {
    return this.http.post(`${this.url}airMaster/getMasterById`, airSearchDto);
  }
  getAIRItemsListData(airSearchDto: AIRSearchDTO) {
    return this.http.post(`${this.url}airItems/list`, airSearchDto);
  }
  addDeleteUpdateAIRItem(airSearchDto: AIRSearchDTO) {
    return this.http.post(`${this.url}airItems/crud`, airSearchDto);
  }
  airItemById(airSearchDto: AIRSearchDTO) {
    return this.http.post(`${this.url}airItems/getItemById`, airSearchDto);
  }
  upload(formData) {
    //const formData: FormData = new FormData();
    //formData.append('files', filesArray);
    localStorage.setItem('isUpload', '1');
    return this.http.post<any>(`${this.url}airItems/uploadAIRItems`, formData, {
      headers: {
        Authorization: localStorage.getItem(this.TOKEN),
        'Content-Type': 'multipart/form-data;charset=UTF-8',
      },
      reportProgress: true,
      observe: 'events',
    });
  }

  downloadAIRTemplate() {
    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: authKey,
      }),
    };

    return this.http.get(`${this.url}airMaster/download-air-template`, httpOptions);
  }
  downloadAIRMasterItems(airSearchDto: AIRSearchDTO) {
    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: authKey,
      }),
    };

    return this.http.post(`${this.url}airMaster/download-air-items`, airSearchDto, httpOptions);
  }
}
